<template>
  <div class="ko-exc" style="position: relative">
    <div v-if="errorMsg !== null" class="error"> {{ errorMsg }}</div>
    <div class="text-center p-3" style="z-index: 100" v-if="isLoading"><img style="vertical-align: middle" :src="loadingUrl"> {{ $t('loading') }} ...</div>
    <div v-if="isDataLoaded">

      <table class="center dynamictable dataTable stripped w600 sticky-header">
        <caption class="header">Kumulatívny počet od začiatku roka {{ rok }} do dňa {{ datum }}</caption>
        <thead>
        <tr>
          <th :class="`w200 text-left ` + sorted('station_name')"><a href="#!" @click="do_sort('station_name')" class="d-block text-decoration-none">Stanica</a></th>
          <th :class="`text-center ` + sorted('PM10_24')" style="width: 70px"><a href="#!" @click="do_sort('PM10_24')"  class="d-block text-decoration-none">PM<sub>10</sub></a></th>
          <th :class="`text-center ` + sorted('O3_8')" style="width: 70px"><a href="#!" @click="do_sort('O3_8')"  class="d-block text-decoration-none">O<sub>3</sub></a></th>
          <th :class="`text-center ` + sorted('SO2_24')" style="width: 70px" colspan="2"><a href="#!" @click="do_sort('SO2_24')"  class="d-block text-decoration-none">SO<sub>2</sub></a></th>
          <th :class="`text-center ` + sorted('CO_8')" style="width: 70px"><a href="#!" @click="do_sort('CO_8')"  class="d-block text-decoration-none">CO</a></th>
          <th :class="`text-center ` + sorted('NO2_1')" style="width: 70px"><a href="#!" @click="do_sort('NO2_1')"  class="d-block text-decoration-none">NO<sub>2</sub></a></th>
        </tr>
        <tr>
          <th class="py-0 ">&nbsp;</th>
          <th class="py-0 text-center small">24h</th>
          <th class="py-0 text-center small">8h**</th>
          <th :class="`py-0 text-center small ` + sorted('SO2_1')" style="width: 35px"><a href="#!" @click="do_sort('SO2_1')"  class="d-block text-decoration-none">1h</a></th>
          <th :class="`py-0 text-center small ` + sorted('SO2_24')" style="width: 35px"><a href="#!" @click="do_sort('SO2_24')"  class="d-block text-decoration-none">24h</a></th>
          <th class="py-0 text-center small">8h</th>
          <th class="py-0 text-center small">1h</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="station in sortedList">
          <tr>
            <td class="text-left nowrap">{{ station.station_name }}</td>
            <td :class="getExcClass('PM10', getExcValue('PM10', station.station_id, 24), 24, station.station_id)" v-html="getExcValue('PM10',station.station_id, 24)"></td>
            <td :class="getExcClass('O3', getExcValue('O3',station.station_id, 8),8, station.station_id)" v-html="getExcValue('O3',station.station_id, 8)"></td>
            <td :class="getExcClass('SO2', getExcValue('SO2', station.station_id,1), 1, station.station_id)" v-html="getExcValue('SO2',station.station_id, 1)"></td>
            <td :class="getExcClass('SO2', getExcValue('SO2',station.station_id, 24), 24, station.station_id)" v-html="getExcValue('SO2',station.station_id, 24)"></td>
            <td :class="getExcClass('CO', getExcValue('CO', station.station_id,8), 8, station.station_id)" v-html="getExcValue('CO',station.station_id, 8)"></td>
            <td :class="getExcClass('NO2', getExcValue('NO2',station.station_id, 1), 1, station.station_id)" v-html="getExcValue('NO2',station.station_id, 1)"></td>
          </tr>
        </template>
        </tbody>
      </table>
      <div class="text-left mt-3">
        <small>* Horské stanice, kde dochádza k zvýšeným hodnotám koncentrácií ozónu z dôvodu prenosu z vyšších vrstiev troposféry a stratosféry.</small>
        <br><small>** V tejto tabuľke sa uvádza počet prekročení len v aktuálnom roku. Cieľová hodnota pre ozón na ochranu zdravia ľudí je určená nasledovne: Najväčšia denná 8-hodinová stredná hodnota koncentrácie neprekročí 120 µg/m<sup>3</sup> viac ako 25 dní za kalendárny rok v priemere troch rokov.</small>
      </div>

    </div>


  </div>
</template>

<script>

import SHMUconf from '../../shmu_conf';
import Axios from "axios";

export default {
  name: 'KoEXC',
  data() {
    return {
      listOfDates: [],
      allStations: [],
      loadedData: [],
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      isError: false,
      errorMsg: null,
      isAllStationsLoaded: false,
      isDataLoaded: false,
      isLoading: false,
      selectedDate: null,
      iIndex: null,
      prevDisabled: false,
      nextDisabled: false,
      sortDir: 1,
      sortBy: 'poradie',
      setNullValueFor: [
        { station_id: 11952, pollutant: 'PM10' },
        { station_id: 11958, pollutant: 'PM10' },
      ],
      setIngoreLimisFor: [
        { station_id: 11916, pollutant: 'O3' },
        { station_id: 11958, pollutant: 'O3' },
      ]
    }
  },
  watch: {},
  mounted() {
    this.getStations();

  },
  computed: {
    stations() {
      return this.allStations.filter( item => parseInt(item.has_exc) === 1);
    },
    sortedList() {
      let r = [...this.stations]
          .map( station => ({
            ...station,
            PM10_24:  this.getExcValueNum('PM10', station.station_id, 24),
            O3_8 : this.getExcValueNum('O3', station.station_id, 8),
            SO2_1: this.getExcValueNum('SO2', station.station_id, 1),
            SO2_24: this.getExcValueNum('SO2', station.station_id, 24),
            CO_8: this.getExcValueNum('CO', station.station_id, 8),
            NO2_1: this.getExcValueNum('NO2', station.station_id, 1),
          })).sort((a,b) => {
            if (a[this.sortBy] > b[this.sortBy]) {
              return this.sortDir
            }
            return -this.sortDir;
          })
      return r;

    },
    base_dt() {
      return this.loadedData[0].data[0].dt;
    },
    datum() {
      return this.$moment(this.base_dt).format('DD.MM.YYYY');
    },
    rok() {
      return this.$moment(this.base_dt).format('YYYY');
    }

  },
  methods: {
    getStations() {
      const self = this;

      self.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getstations', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {

          self.allStations = response.data;
          self.isAllStationsLoaded = true;
          self.isError = false;
          self.errorMsg = null;
          self.getData();


        } else {
          self.isError = true;
          if (response.data.error[0].text) {
            self.errorMsg = response.data.error[0].text;
          } else {
            self.errorMsg = 'Nastala chyba pri načítavaní staníc kvality ovzdušia!';
          }
        }
        self.isLoading = false;
      }).catch((error) => {
        console.log(error);
        self.isError = true;
        self.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        self.isLoading = false;
      });


    },
    getData() {
      const self = this;

      self.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getexcdata', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {

          self.loadedData = response.data;

          if (self.loadedData.length) {

            self.isDataLoaded = true;
            self.isError = false;
            self.errorMsg = null;

          } else {
            self.isError = true;
            self.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }


        } else {
          self.isError = true;
          if (response.data.error[0].text) {
            self.errorMsg = response.data.error[0].text;
          } else {
            self.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        self.isLoading = false;
      }).catch((error) => {
        console.log(error);
        self.isError = true;
        self.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        self.isLoading = false;
      });

    },
    getExcClass(pollutant, value, cas, station_id) {

      let base_class = 'oko_0';
      // limity
      if (pollutant === 'SO2') {
        if (cas === 1 && value > 24) base_class = 'oko_4';
        if (cas === 24 && value > 3) base_class = 'oko_4';
      } else if (pollutant === 'NO2') {
        if (cas === 1 && value > 18) base_class = 'oko_4';
      } else if (pollutant === 'PM10') {
        if (cas === 24 && value > 35) base_class = 'oko_4';
      } else if (pollutant === 'O3') {
        if (cas === 8 && value > 25) base_class = 'oko_3';
      }

      if (value === '') base_class = '';

      let r = this.setIngoreLimisFor.find( item => item.station_id == station_id && pollutant == item.pollutant);
      if (r) {
        base_class = 'oko_0';
      }



      return 'text-center ' + base_class;
    },
    getExcValue(pollutant, station_id, cas) {
      const self = this;



      let r = self.setNullValueFor.find( item => item.station_id == station_id && pollutant == item.pollutant);
      if (r) {
        return '';
      }


      let res = this.loadedData.find(item => parseInt(item.station_id) === parseInt(station_id));
      if (res) {
        let data = res.data.find(item => item.dt === self.base_dt && item.pollutant === pollutant && parseInt(item.in_hours) === parseInt(cas));
        if (data) {

          let r = this.setIngoreLimisFor.find( item => item.station_id == station_id && pollutant == item.pollutant);
          let add = '';
          if (r) {
            add = '*';
          }


          return data.exc_count + add;
        }
      }
      return '';
    },
    getExcValueNum(pollutant, station_id, cas) {
      const self = this;

      let r = self.setNullValueFor.find( item => item.station_id == station_id && pollutant == item.pollutant);
      if (r) {
        return -1;
      }

      let res = this.loadedData.find(item => parseInt(item.station_id) === parseInt(station_id));
      if (res) {
        let data = res.data.find(item => item.dt === self.base_dt && item.pollutant === pollutant && parseInt(item.in_hours) === parseInt(cas));
        if (data) {
          return parseInt(data.exc_count);
        }
      }
      return -1;
    },
    sorted(col) {
      if (col === this.sortBy) {
        //    return  ((this.sortDir === 1) ? '<i class="icon-chevron-down"></i>' : '<i class="icon-chevron-up"></i>')
        return  ((this.sortDir === 1) ? 'sorting sorting_asc' : 'sorting sorting_desc')
      }
      return 'sorting';
    },
    /*
    sorted(col) {
      switch (col) {
        case 'station_name': { return (this.sortBy === 'station_name') ? ((this.sortDir === 1) ? '<i class="icon-chevron-down"></i>' : '<i class="icon-chevron-up"></i>') : ''; break; }
        case 'PM10_24': { return (this.sortBy === 'PM10_24') ? ((this.sortDir === 1) ? '<i class="icon-chevron-down"></i>' : '<i class="icon-chevron-up"></i>') : ''; break; }
        case 'O3_8': { return (this.sortBy === 'O3_8') ? ((this.sortDir === 1) ? '<i class="icon-chevron-down"></i>' : '<i class="icon-chevron-up"></i>') : ''; break;  }
        case 'SO2_1': { return (this.sortBy === 'SO2_1') ? ((this.sortDir === 1) ? '<i class="icon-chevron-down"></i>' : '<i class="icon-chevron-up"></i>') : ''; break;  }
        case 'SO2_24': { return (this.sortBy === 'SO2_24') ? ((this.sortDir === 1) ? '<i class="icon-chevron-down"></i>' : '<i class="icon-chevron-up"></i>') : ''; break;  }
        case 'CO_8': { return (this.sortBy === 'CO_8') ? ((this.sortDir === 1) ? '<i class="icon-chevron-down"></i>' : '<i class="icon-chevron-up"></i>') : ''; break;  }
        case 'NO2_1': { return (this.sortBy === 'NO2_1') ? ((this.sortDir === 1) ? 'sorting sorting_asc' : 'sorting sorting_desc') : 'sorting'; break;  }
        default : { return 'sorting'; break;  }
      }

      return 'sorting';
    },

     */
    do_sort(col) {
      this.sortBy = col;
      if (this.sortDir === 1) {
        this.sortDir = -1;
      } else {
        this.sortDir = 1;
      }

    }

  }
}
</script>

